export type SwipeDirection = "left" | "right" | null

export default class SwipeGesture {
  private startX: number | null = null
  private startY: number | null = null
  private endX: number | null = null
  private endY: number | null = null
  private didSwipe = false
  private readonly threshold: number

  constructor(threshold = 50) {
    this.threshold = threshold
  }

  start(clientX: number, clientY: number): void {
    this.startX = clientX
    this.startY = clientY
    this.endX = clientX
    this.endY = clientY
    this.didSwipe = false
  }

  move(clientX: number, clientY: number): void {
    this.endX = clientX
    this.endY = clientY
  }

  end(): SwipeDirection {
    if (
      this.startX === null ||
      this.startY === null ||
      this.endX === null ||
      this.endY === null
    ) {
      return null
    }

    const deltaX = this.startX - this.endX
    const deltaY = this.startY - this.endY
    const isHorizontalSwipe =
      Math.abs(deltaX) > this.threshold && Math.abs(deltaX) > Math.abs(deltaY)

    const direction: SwipeDirection = isHorizontalSwipe
      ? deltaX > 0
        ? "left"
        : "right"
      : null

    this.didSwipe = direction !== null
    this.reset()
    return direction
  }

  consumeDidSwipe(): boolean {
    const value = this.didSwipe
    this.didSwipe = false
    return value
  }

  private reset(): void {
    this.startX = null
    this.startY = null
    this.endX = null
    this.endY = null
  }
}
